import { Icon, Text } from '@dixa/lib-shared-habla';
import classNames from 'classnames';
import type { InstrumentPanel } from 'lib-analytics-types';
import { ampli } from 'lib-shared-tracking';
import { HTMLDataAttributes, PropsWithClassName } from 'lib-shared-types-utils';

import { useAnalyticsState } from 'analytics/components/panels/utils/useAnalyticsState/useAnalyticsState';

import {
  InstrumentPanelDescription,
  InstrumentPanelDescriptionProps,
} from '../description/instrumentPanelDescription';

import styles from './instrumentPanelTitle.module.scss';

export type InstrumentPanelTitleProps = {
  /** The instrument panel. */
  panel: InstrumentPanel;
  /** A custom element to display before the title for additional context. */
  prefix?: JSX.Element;
  /** Called when the description is changed. */
  onChangeDescription?: InstrumentPanelDescriptionProps['onChange'];
} & PropsWithClassName &
  HTMLDataAttributes<string>;

export const InstrumentPanelTitle = ({
  className,
  panel,
  prefix,
  onChangeDescription,
  ...rest
}: InstrumentPanelTitleProps): JSX.Element => {
  const { dashboard } = useAnalyticsState(panel);

  const handleHelperClick = () => {
    ampli.analyticsHelperClicked({
      panel: panel.title,
      dashboard: dashboard.title,
    });
  };

  return (
    <div className={classNames(styles.root, className)} {...rest}>
      <div className={styles.title}>
        {prefix}

        <Text.Heading variant="heading-3">{panel.title}</Text.Heading>

        <div
          className={styles.helper}
          role="button"
          data-analytics-panel-helper
          data-elevio-allow-propagation
          onClick={handleHelperClick}
        >
          <Icon name="info" />
        </div>
      </div>

      <InstrumentPanelDescription
        panel={panel}
        onChange={onChangeDescription}
      />
    </div>
  );
};
